import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  Table,
  TablePagination,
  TableCell,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
} from "@material-ui/core";
import { ManagementTypes } from '../../../utils/ManagementTypes';
import Skeleton from "@mui/material/Skeleton";
import {
  getUserGroups,
  getAllAuthorities,
  createDAAQ,
  createUserGroup,
  addDAAQToUserGroup,
  addAuthorityToUserGroup,
  deleteUserGroup,
  updateUserGroup,
  removeDAAQFromUserGroup,
  removeAuthorityFromUserGroup,
  getAllDaaqs,
} from "../../../store/action/user.js";
import { getAllAgency } from "../../../store/action/claim.js";
import "./UserGroups.css";
import { useDispatch } from "react-redux";
import {
  Accordion,
  AccordionPanel,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  Box,
} from "@chakra-ui/react";
import Autocomplete from "@mui/material/Autocomplete";
import { translateAuthorities } from "../../../utils/translateAuthorities.js";
import DialogContentText from "@mui/material/DialogContentText";
import Slide from "@mui/material/Slide";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import convertJsonToExcel from "../../../utils/exportUtils.js";
import {validateInput} from "../../../utils/inputValidation";
import ErrorsAlert from "../../../utils/errorsAlert";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "85vh",
  },
  tableCellSmall: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "21px",
    color: "rgba(70, 78, 95, 1)",
    borderBottom: "1px solid  rgba(0, 0, 0, 0.08)",
  },
  paper: {
    width: "100%",
    borderRadius: "11px",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
  },
  tableWrapper: {
    padding: "40px",
  },
  tableHeadRows: {
    whiteSpace: "nowrap",
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: "18px",
    color: "rgba(181, 181, 195, 1)",
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    padding: "1%",
  },

  tableSortLabel: {
    color: "rgba(32, 29, 35, 1)",
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: 12,
    lineHeight: "18px",
  },
  titre: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    color: "rgba(63, 66, 84, 1)",
  },
  titreLabel: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 400,
    color: "rgba(32, 18, 70, 1)",
  },
  tablePagination: {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    color: "rgba(32, 18, 70, 1)",
  },
  dateRangeContainer: {
    display: "flex",
    alignItems: "center",
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    borderRadius: 5,
    padding: "5px 10px",
  },
  dateContainer: {
    border: "none",
    outline: "none",
    background: "rgba(255, 255, 255, 1)",
    borderRadius: 5,
    fontFamily: "Poppins",
    paddingLeft: "5px",
  },
  inputContainer: {
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    width: "148px",
    height: "29.69px",
    borderRadius: 5,
    marginLeft: "20px",
  },
  viewBtn: {
    width: "40px",
    height: "34px",
    borderRadius: "6px",
    backgroundColor: "rgba(240, 243, 199, 1)",
    border: 0,
    lineHeight: "18px",
    color: "rgba(187, 200, 8, 1)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center", 
    cursor: "pointer",
  },
  taskNameColumn: {
    width: "114px",
    height: "20px",
    gap: "0px",
    fontFamily: "Poppins",
    fontSize: "10.17px",
    fontWeight: 500,
    textAlign: "left",
    color: "rgba(187, 200, 8, 1)",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  tableContent: {
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: 400,
    //lineHeight: 19.6,
    textAlign: "left",
    color: "rgba(32, 29, 35, 0.8)",
    paragraph: {
      lineHeight: "32.69px",
    },
  },
  sinistres: {
    fontFamily: "Poppins",
    fontSize: 14,
    fontWeight: 600,
    textAlign: "left",
    color: "rgba(70, 78, 95, 1)",
  },
  dropdownMenu: {
    position: "absolute",
    zIndex: 1,
    backgroundColor: "white",
    border: "0.61px solid rgba(226, 217, 239, 1)",
    //boxShadow: theme.shadows[5],
    marginRight: "110px",
    borderRadius: 6,
  },
  dropdownItem: {
    padding: theme.spacing(1),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
  },
  naText: {
    color: "rgb(145, 145, 145)",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paperModal: {
    backgroundColor: "rgba(255, 255, 255, 1)",
    border: "none",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
    padding: theme.spacing(2, 4, 3),
    width: "459px",
    height: "175px",
  },
  modalTitle: {
    fontFamily: "Poppins",
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "21px",
    textAlign: "left",
    marginBottom: "16px",
  },
  // dialogTitle: {
  //   fontFamily: "Poppins",
  //   fontWeight: 500,
  //   fontSize: 15,
  //   color: "rgba(63, 66, 84, 1)",
  //   backgroundColor: "white",
  //   borderBottom: "1px solid #E5EAEE",
  // },
  line: {
    height: "2px",
    backgroundColor: "rgba(243, 246, 249, 1)",
    width: "100%",
    marginBottom: "16px",
  },
  selectModal: {
    width: "400px",
    height: "36px",
    borderRadius: "4px",
    border: "1px solid rgba(222, 222, 222, 1)",
  },
  CancelStyle: {
    marginLeft: "20px",
    width: "62px",
    height: "26px",
    color: "rgb(255, 54, 54)",
    backgroundColor: " rgb(255, 229, 229)",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    border: 0,
    cursor: "pointer",
  },
  ajouterStyle: {
    marginLeft: "20px",
    width: "62px",
    height: "26px",
    backgroundColor: "rgba(187, 200, 8, 1)",
    color: "rgba(255, 255, 255, 1)",
    borderRadius: "5.38px",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    border: 0,
    cursor: "pointer",
  },
  TextContainer: {
    display: "flex",
    justifyContent: "space-between",
    margin: "10px 15px",
  },
  dialogContent: {
    overflowY: "auto",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  cardText: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 400,
    color: "rgba(70, 78, 95, 1)",
  },
  cardValue: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 500,
    color: "rgba(24, 28, 50, 1)",
    textAlign: "Right",
  },
  styleInput: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 500,
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    color: "rgba(24, 28, 50, 0.58)",
    lineHeight: "21px",
    padding: "5px",
    width: "240px",
    height: "36px",
    borderRadius: "4px",
  },
  card: {
    backgroundColor: "white",
    borderRadius: "8px",
    width: "100%",
    height: "680px",
    border: "0.61px solid rgba(226, 217, 239, 1)",
  },
  dialogPaper: {
    width: "700px",
    overflow: "hidden",
  },
  selectInput: {
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    width: "148px",
    height: "29.69px",
    borderRadius: 5,
    marginLeft: "20px",
  },
  selectInputDialog: {
    width: "100%",
    border: "0",
    padding: "5px",
    background: "rgba(243, 246, 249, 1)",
    height: "29.69px",
    borderRadius: 5,
    alignItems: "center",
    justifyContent: "center",
  },
  optionLabel: {
    width: "150px",
    padding: theme.spacing(1),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
  },
  dialogTitle: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: 15,
    color: "rgba(63, 66, 84, 1)",
    backgroundColor: "white",
    borderBottom: "1px solid #E5EAEE",
  },
  optionItem: {
    width: "100%",
    padding: theme.spacing(1),
    cursor: "pointer",
    backgroundColor: "white",
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    specialInput: {
      color: "rgba(24, 28, 50, 0.58)",
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: 500,
      textAlign: "right",
      backgroundColor: "rgba(243, 246, 249, 1)",
      border: "none",
      width: "209px",
      height: "28px",
    },
  },
}));
export default function UserGroupsList(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [userGroups, setUserGroups] = useState([]);
  const [userGroupsFilter, setUserGroupsFilter] = useState([]);
  const [nomGroup, setNomGroup] = useState("");
  const [codeGroup, setCodeGroup] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [nom, setNom] = useState("");
  const [code, setCode] = useState("");
  const [selectedDAAQs, setSelectedDAAQs] = useState([]);
  const [selectedAuthorities, setSelectedAuthorities] = useState([]);
  const [selectedAgencies, setSelectedAgencies] = useState([]);
  const [groupAuthorities, setGroupAuthorities] = useState([]);
  const [authorities, setAuthorities] = useState([]);
  const [agencies, setAgencies] = useState([]);
  const [managementTypes, setManagementTypes] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [groupToDelete, setGroupToDelete] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [isRequestInProgress, setIsRequestInProgress] = useState(false);
  const [errors, setErrors] = useState([]);

  const handleClickOpen = (group) => {
    setGroupToDelete(group);
    setOpenConfirm(true);
  };
  const handleCloseConfirm = () => {
    setOpenConfirm(false);
    setGroupToDelete(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
  };
  const handleNomGroupeChange = (e) => {
    setNomGroup(e.target.value.toLowerCase());
  }
  const handleCodeGroupeChange = (e) => {
    setCodeGroup(e.target.value.toLowerCase());
  }
  useEffect(() => {
    const fetchAuthorities = async () => {
      const authorities = await dispatch(getAllAuthorities());
      setAuthorities(authorities);
    };

    const fetchUserGroups = async () => {
      const groups = await dispatch(getUserGroups());
      setUserGroups(groups);
      setUserGroupsFilter(groups);
      setLoading(false);
    };
    const fetchAgencies = async () => {
      const ag = await dispatch(getAllAgency());
      setAgencies(ag);
    };
    setManagementTypes(ManagementTypes);
    if (selectedDAAQs.length === 0) {
      setSelectedAgencies([]);
    }
    fetchAgencies();
    fetchAuthorities();
    fetchUserGroups();
  }, [dispatch]);

  useEffect(() => {
    const filterUserGroups = () => {
      let filteredGroups = userGroups;
      
       if (nomGroup) {
        filteredGroups = filteredGroups.filter((group) =>
          group.label.toLowerCase().includes(nomGroup.toLowerCase())
        );
      }
      if (codeGroup) {
        filteredGroups = filteredGroups.filter((group) =>
          group.uid.toLowerCase().includes(codeGroup.toLowerCase())
        );
      }
      
       setUserGroupsFilter(filteredGroups);
  
       const newPage = Math.floor(filteredGroups?.length / rowsPerPage);
      setPage(Math.min(newPage, page));
    };
  
    filterUserGroups();
  }, [nomGroup, codeGroup, userGroups, rowsPerPage, page]);
  
  useEffect(() => {
    if (selectedDAAQs.length === 0) {
      setSelectedAgencies([]);
    }
  }, [selectedDAAQs]);
  const handleEditGroup = (group) => {
    setSelectedGroup(group);
    setIsEditing(true);
    setNom(group.label);
    setCode(group.uid);
    const updatedDAAQs = group.grouupDAAQs
      .map((daq) => ({
        label: getManagementTypeFromDaaqLabel(daq.readDAAQ).toUpperCase(),
      }))
      .filter(
        (value, index, self) =>
          value.label !== "Unknown" &&
          index === self.findIndex((t) => t.label === value.label)
      );

    setSelectedDAAQs(updatedDAAQs);
    const updatedAgencies = group.grouupDAAQs
      .map((daq) => ({
        label: getAgencyFromDaaqLabel(daq.readDAAQ),
      }))
      .filter(
        (value, index, self) =>
          value.label !== "Unknown" &&
          index === self.findIndex((t) => t.label === value.label)
      );
    setSelectedAgencies(updatedAgencies);

    setSelectedAuthorities(group.groupAuthorities);

    setOpen(true);
  };

  const getManagementTypeFromDaaqLabel = (daaqLabel) => {
    if (!daaqLabel) return "Unknown";

    const parts = daaqLabel.split("/");

    if (parts.length >= 3) {
      const label = parts[2].toUpperCase();

      const managementType = managementTypes.find(
        (item) => item.label === label
      );
      return managementType ? managementType.label : "Unknown";
    }

    return "Unknown";
  };

  const getAgencyFromDaaqLabel = (daaqLabel, stateAgencies = []) => {
    if (!daaqLabel) return "Unknown";

    const parts = daaqLabel.split("/");

    if (parts.length >= 4) {
      const agencyLabel = parts[3];
      const agency = agencies.find((agency) => agency.label === agencyLabel);
      return agency ? agency.label : "Unknown";
    }

    return "Unknown";
  };
  const handleAddGroup = () => {
    // "" et non null : un input contrôlé passé à null garde l'ancien texte à l'écran
    setCode("");
    setNom("");
    setSelectedAgencies([]);
    setSelectedAuthorities([]);
    setSelectedDAAQs([]);
    setSelectedGroup(null);
    setIsEditing(false);
    setOpen(true);
  };

  const handleCloseDialog = () => {
    // Réinitialise le formulaire, pas les filtres de la liste (nomGroup / codeGroup)
    setOpen(false);
    setNom("");
    setCode("");
    setSelectedDAAQs([]);
    setSelectedAgencies([]);
    setSelectedAuthorities([]);
    setSelectedGroup(null);
    setIsEditing(false);
  };
  const handleDAAQChange = (event, newValue) => {
    setSelectedDAAQs(newValue);
  };

  const handleAuthorityChange = (event, newValue) => {
    setSelectedAuthorities(newValue);
  };

  const handleAgencyChange = (event, newValue) => {
    setSelectedAgencies(newValue);
  };
  const handleSubmit = async () => {
    if (!nom || !code) {
      toast.error("Le code et le nom du groupe sont obligatoires");
      return;
    }
    setIsRequestInProgress(true);
    let hasError = false;
    // Les thunks add/remove renvoient undefined en cas d'échec HTTP : on le trace au lieu de l'ignorer
    const track = (result, what) => {
      if (!result) {
        hasError = true;
        console.error(`[UserGroups] ${what} a échoué`);
      }
      return result;
    };
    const buildReadDAAQ = (daaq, agency) =>
      agency ? `/claim/${daaq.label.toLowerCase()}/${agency.label}` : `/claim/${daaq.label.toLowerCase()}`;
    const selectedDaaqLabels = selectedDAAQs.flatMap((daaq) =>
      selectedAgencies.length > 0
        ? selectedAgencies.map((agency) => buildReadDAAQ(daaq, agency))
        : [buildReadDAAQ(daaq, null)]
    );
    const ensureDaaq = async (allDaaqs, readDAAQ) => {
      const existing = allDaaqs.find((daaq) => daaq.readDAAQ === readDAAQ);
      if (existing) return existing;
      const created = await dispatch(createDAAQ({ label: `${nom}_${code}`, readDAAQ, updateDAAQ: readDAAQ }));
      return created && created.uid ? created : null;
    };
    // Un DAAQ que le formulaire ne sait pas représenter (typologie ou agence hors référentiel) ne doit jamais être retiré
    const isRepresentable = (daaq) => {
      const parts = (daaq.readDAAQ || "").split("/");
      if (getManagementTypeFromDaaqLabel(daaq.readDAAQ) === "Unknown") return false;
      return parts.length <= 3 || getAgencyFromDaaqLabel(daaq.readDAAQ) !== "Unknown";
    };

    try {
      if (isEditing && selectedGroup) {
        const updated = await dispatch(updateUserGroup(code, { label: nom, uid: code }));
        if (!updated) {
          throw new Error("updateUserGroup failed");
        }

        const existingDaaqs = selectedGroup.grouupDAAQs || [];
        const existingLabels = existingDaaqs.map((daaq) => daaq.readDAAQ);
        const daaqsToRemove = existingDaaqs.filter(
          (daaq) => isRepresentable(daaq) && !selectedDaaqLabels.includes(daaq.readDAAQ)
        );
        const labelsToAdd = selectedDaaqLabels.filter((label) => !existingLabels.includes(label));

        for (const daaq of daaqsToRemove) {
          track(await dispatch(removeDAAQFromUserGroup(selectedGroup.uid, daaq.uid)), `retrait DAAQ ${daaq.readDAAQ}`);
        }
        const allDaaqs = (await dispatch(getAllDaaqs())) || [];
        for (const label of labelsToAdd) {
          const daaq = await ensureDaaq(allDaaqs, label);
          if (!track(daaq, `création DAAQ ${label}`)) continue;
          track(await dispatch(addDAAQToUserGroup(selectedGroup.uid, daaq.uid)), `ajout DAAQ ${label}`);
        }

        const existingAuthorities = selectedGroup.groupAuthorities || [];
        const existingAuthorityUids = existingAuthorities.map((auth) => auth.uid);
        for (const authority of selectedAuthorities.filter((auth) => !existingAuthorityUids.includes(auth.uid))) {
          track(await dispatch(addAuthorityToUserGroup(selectedGroup.uid, authority.uid)), `ajout autorité ${authority.label}`);
        }
        for (const authority of existingAuthorities.filter((auth) => !selectedAuthorities.some((s) => s.uid === auth.uid))) {
          track(await dispatch(removeAuthorityFromUserGroup(selectedGroup.uid, authority.uid)), `retrait autorité ${authority.label}`);
        }
      } else {
        let newGroup;
        try {
          newGroup = await createUserGroup({ label: nom, uid: code });
        } catch (error) {
          // ms-user répond 400 { errors: ['Label already exists'] } sur un doublon : remonter le message serveur
          const serverErrors = error?.response?.data?.errors;
          throw new Error(Array.isArray(serverErrors) ? serverErrors.join(", ") : error.message);
        }
        if (!newGroup || !newGroup.uid) {
          throw new Error("createUserGroup failed");
        }

        const allDaaqs = (await dispatch(getAllDaaqs())) || [];
        for (const label of selectedDaaqLabels) {
          const daaq = await ensureDaaq(allDaaqs, label);
          if (!track(daaq, `création DAAQ ${label}`)) continue;
          track(await dispatch(addDAAQToUserGroup(newGroup.uid, daaq.uid)), `ajout DAAQ ${label}`);
        }
        for (const authority of selectedAuthorities) {
          track(await dispatch(addAuthorityToUserGroup(newGroup.uid, authority.uid)), `ajout autorité ${authority.label}`);
        }
      }

      const updatedGroups = await dispatch(getUserGroups());
      setUserGroups(updatedGroups);
      setUserGroupsFilter(updatedGroups);
      if (hasError) {
        toast.error("Groupe enregistré, mais certains DAAQ ou autorités n'ont pas été enregistrés");
      } else {
        toast.success(isEditing ? "Groupe modifié avec succès" : "Groupe ajouté avec succès");
        handleCloseDialog();
      }
    } catch (error) {
      console.error("[UserGroups] handleSubmit", error);
      toast.error(
        isEditing
          ? "Échec de la modification du groupe"
          : `Échec de la création du groupe : ${error.message}`
      );
    } finally {
      setIsRequestInProgress(false);
    }
  };

  const handleConfirmDelete = async () => {
    if (!groupToDelete) return;
    setIsRequestInProgress(true);
    try {
      const deleted = await dispatch(deleteUserGroup(groupToDelete.uid));
      if (!deleted) {
        throw new Error("deleteUserGroup failed");
      }
      const updatedGroups = await dispatch(getUserGroups());
      setUserGroups(updatedGroups);
      setUserGroupsFilter(updatedGroups);
      toast.success("Groupe supprimé avec succès");
    } catch (error) {
      console.error("[UserGroups] handleConfirmDelete", error);
      toast.error("Échec de la suppression du groupe");
    } finally {
      setIsRequestInProgress(false);
      setOpenConfirm(false);
      setGroupToDelete(null);
    }
  };

  const headRows = [
    { id: "uid", align: "left", label: "Code Groupe", width: "15%" },
    { id: "label", align: "left", label: "Nom Groupe", width: "28%" },
    { id: "createdAt", align: "left", label: "Date Création", width: "18%" },
    {
      id: "updatedAt",
      align: "left",
      label: "Date Modification",
      width: "18%",
    },
    { id: "", align: "center", label: "", width: "25%" },
  ];
  function handleExport() {
    const fieldMappings = {};

     headRows.forEach(row => {
        if (row.id && row.label) {
            if (row.label.toLowerCase().includes("date")) {
                 fieldMappings[row.label] = item => getDateFromString(item[row.id]);
            } else {
                 fieldMappings[row.label] = row.id;
            }
        }
    });

     convertJsonToExcel(userGroups, 'UserGroups.xlsx', fieldMappings);
}

  function getDateFromString(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${day}/${month}/${year} à ${hours}:${minutes}`;
  }

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <div className={classes.tableWrapper}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "40px",
            }}
          >
            <div
              className={classes.titre}
              style={{ width: "18%", whiteSpace: "nowrap" }}
            >
              Liste des groups utilisateur
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "80%",
                justifyContent: "flex-end",
              }}
            >
              <div
                className={classes.titre}
                style={{ marginRight: "15px", whiteSpace: "nowrap" }}
              >
                Filtrer par
              </div>
              <div
                className={classes.titreLabel}
                style={{
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                }}
              >
                Nom Groupe
                <input
                  type="text"
                  className={classes.inputContainer}
                  style={{ width: "120px", marginLeft: "10px" }}
                  onChange={handleNomGroupeChange}
                />
              </div>
              <div
                className={classes.titreLabel}
                style={{
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                  marginLeft: "1rem",
                }}
              >
                Code Groupe
                <input
                  type="text"
                  className={classes.inputContainer}
                  style={{ width: "120px", marginLeft: "10px", marginRight:"10px" }}
                  onChange={handleCodeGroupeChange}
                />
              </div>
            </div>
            <Box display="flex" alignItems="center" gap="10px">
              {/* <Button
                style={{
                  width: "64px",
                  height: "27px",
                  color: "rgba(186, 200, 9, 1)",
                  borderColor: "rgba(186, 200, 9, 1)",
                  borderWidth: "1px",
                  borderStyle: "solid",
                  borderRadius: "5px",
                  fontFamily: "Poppins",
                  fontWeight: "400",
                  fontSize: "11px",
                  lineHeight: "16px",
                }}
                onClick={handleExport}
              >
                Export
              </Button> */}
              <Button
                style={{
                  width: "110px",
                  height: "27px",
                  color: "rgba(186, 200, 9, 1)",
                  borderColor: "rgba(186, 200, 9, 1)",
                  borderWidth: "1px",
                  borderStyle: "solid",
                  borderRadius: "5px",
                  fontFamily: "Poppins",
                  fontWeight: "400",
                  fontSize: "11px",
                  lineHeight: "16px",
                }}
                onClick={handleAddGroup}
              >
                Créer Groupe
              </Button>
            </Box>
          </div>
          <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size="small"
          >
            <thead>
            <tr>
              {headRows.map((row) => (
                  <TableCell
                      height={"43px"}
                      width={row.width}
                      align={row.align}
                      className={classes.tableHeadRows}
                      key={row.id}
                  >
                    {row.label}
                  </TableCell>
              ))}
            </tr>
            </thead>
            <tbody>
            {loading ? (
                [...Array(10)].map((_, index) => (
                    <tr key={index} style={{ height: "48px" }}>
                      {[...Array(5)].map((_, i) => (
                          <TableCell
                              key={i}
                              align={i === 4 ? "center" : "left"}
                              className={classes.tableCellSmall}
                          >
                            <Skeleton animation="wave" />
                          </TableCell>
                      ))}
                    </tr>
                ))
            ) : userGroupsFilter?.length > 0 ? (
                userGroupsFilter
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((group, index) => (
                        <tr key={index} style={{ height: "48px" }}>
                          <TableCell align="left" className={classes.tableCellSmall}>
                            {group.uid}
                          </TableCell>
                          <TableCell align="left" className={classes.tableCellSmall}>
                            {group.label}
                          </TableCell>
                          <TableCell align="left" className={classes.tableCellSmall}>
                            {getDateFromString(group.createdAt) || "N/A"}
                          </TableCell>
                          <TableCell align="left" className={classes.tableCellSmall}>
                            {getDateFromString(group.updatedAt) || "N/A"}
                          </TableCell>
                          <TableCell align="right" className={classes.tableCellSmall}>
                            <button
                                style={{
                                  width: "80px",
                                  height: "34px",
                                  borderRadius: "6px",
                                  background: "rgba(187, 200, 8, 1)",
                                  border: 0,
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  lineHeight: "18px",
                                  color: "rgba(255,255,255,1)",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleEditGroup(group)}
                            >
                              Modifier
                            </button>
                            <button
                                style={{
                                  width: "80px",
                                  height: "34px",
                                  borderRadius: "6px",
                                  background: "rgba(255, 229, 229, 1)",
                                  border: 0,
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  lineHeight: "18px",
                                  marginLeft: "10px",
                                  color: "rgba(255, 54, 54, 1)",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleClickOpen(group)}
                            >
                              Supprimer
                            </button>
                          </TableCell>
                        </tr>
                    ))
            ) : (
                <tr>
                  <TableCell
                      align="center"
                      style={{
                        fontFamily: "Poppins",
                        fontWeight: 400,
                        fontSize: 15,
                        lineHeight: "22.5px",
                        color: "rgba(70, 78, 95, 1)",
                        padding: "20px",
                      }}
                      colSpan="6"
                  >
                    Aucune groupe disponible
                  </TableCell>
                </tr>
            )}
            </tbody>
          </Table>

          <TablePagination
            rowsPerPageOptions={[10, 20, 30]}
            component="div"
            count={userGroupsFilter?.length || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Previous Page",
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page",
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            style={{
              fontFamily: "Poppins",
              fontSize: "12px",
              fontWeight: 400,
              lineHeight: "18px",
              color: "rgba(32, 18, 70, 1)",
            }}
            labelRowsPerPage="Lignes par page"
          />
        </div>
      </Paper>

      <Dialog
        fullWidth
        maxWidth="xl"
        open={open}
        onClose={handleCloseDialog}
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogTitle
          className={classes.dialogTitle}
          style={{ backgroundColor: "rgba(243, 246, 249, 1)" }}
        >
          {isEditing ? "Modification Groupe" : "Création Groupe"}
        </DialogTitle>
        <DialogContent>
          <Accordion allowMultiple defaultIndex={[0, 1, 2]}>
            {" "}
            <AccordionItem>
              <AccordionButton
                style={{
                  height: "47px",
                  border: "none",
                  background: "rgba(255, 255, 255, 1)",
                  borderBottom: "none",
                }}
              >
                <AccordionIcon
                  size="30px"
                  style={{
                    backgroundColor: "rgba(240, 243, 199, 1)",
                    width: "25px",
                    height: "25px",
                    borderRadius: "5px",
                    color: "rgba(187, 200, 8, 1)",
                  }}
                />
                <Box
                  as="div"
                  textAlign="left"
                  marginLeft="20px"
                  style={{
                    color: "rgba(0, 34, 38, 1)",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "21px",
                    fontFamily: "Poppins",
                  }}
                >
                  Informations générales
                </Box>
              </AccordionButton>
              <AccordionPanel>
                <div style={{ marginLeft: "1rem" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "1rem",
                    }}
                  >
                    <label
                      className={classes.cardText}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      Code Groupe
                    </label>
                    <input
                      className={classes.styleInput}
                      style={{ width: "100%" }}
                      disabled={isEditing}
                      value={code}
                      onChange={(e) => {
                        if (validateInput(e.target.value)) {
                          setCode(e.target.value);
                          setErrors([]);
                        } else {
                          setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                        }
                      }}
                    />
                    <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "1rem",
                    }}
                  >
                    <label
                      className={classes.cardText}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      Nom Groupe
                    </label>
                    <input
                      className={classes.styleInput}
                      style={{ width: "100%" }}
                      value={nom}
                      onChange={(e) => {
                        if (validateInput(e.target.value)) {
                          setNom(e.target.value);
                          setErrors([]);
                        } else {
                          setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                        }
                      }}
                    />
                    <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                  </div>
                </div>
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <AccordionButton
                style={{
                  height: "47px",
                  border: "none",
                  background: "rgba(255, 255, 255, 1)",
                  borderBottom: "none",
                }}
              >
                <AccordionIcon
                  size="30px"
                  style={{
                    backgroundColor: "rgba(240, 243, 199, 1)",
                    width: "25px",
                    height: "25px",
                    borderRadius: "5px",
                    color: "rgba(187, 200, 8, 1)",
                  }}
                />
                <Box
                  as="div"
                  textAlign="left"
                  marginLeft="20px"
                  style={{
                    color: "rgba(0, 34, 38, 1)",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "21px",
                    fontFamily: "Poppins",
                  }}
                >
                  Visibilité sinistre
                </Box>
              </AccordionButton>
              <AccordionPanel>
                <div style={{ marginLeft: "1rem" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "1rem",
                    }}
                  >
                    <label
                      className={classes.cardText}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      Typologie de sinistre
                    </label>
                    <Autocomplete
                      multiple
                      id="Typologie"
                      options={managementTypes}
                      value={selectedDAAQs}
                      size="small"
                      onChange={handleDAAQChange}
                      getOptionLabel={(option) => option.label}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          className={`${props.className} ${classes.optionItem}`}
                        >
                          {option.label}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                            placeholder:
                              selectedDAAQs.length < 1
                                ? "Typologie de sinistre"
                                : "",
                            endAdornment: null,
                            classes: {
                              root: classes.selectInputDialog,
                            },
                          }}
                        />
                      )}
                      sx={{
                        fontFamily: "Poppins, sans-serif",
                        "& .MuiOutlinedInput-root": {
                          p: 1,
                          height: "fit-content",
                          width: "100%",
                          backgroundColor: "rgba(243, 246, 249, 1)",
                          fontSize: "0.75rem",
                          display: "flex",
                          justifyContent:"space-between",
                          fontFamily: "Poppins",
                          border: "none",
                            "& fieldset": {
                            border: "none",
                          },
                        },
                        "& .MuiAutocomplete-popupIndicator": {
                          display: "none",
                        },
                        "& .MuiAutocomplete-tag": {
                          bgcolor: "rgba(240, 243, 199, 1)",
                          color: "rgba(187, 200, 8, 1)",
                          border: "none",
                          borderColor: "primary.light",
                          fontSize: "0.75rem",
                          padding: "2px 6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "2px",
                        },
                        "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                          color: "rgba(187, 200, 8, 1)",
                          "&:hover": {
                            color: "rgba(187, 200, 8, 1)",
                          },
                        },
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.label === value.label
                      }
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "1rem",
                    }}
                  >
                    <label
                      className={classes.cardText}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      Agence de sinistre
                    </label>
                    <Autocomplete
                      multiple
                      id="Agency"
                      options={agencies}
                      value={selectedAgencies}
                      disabled={selectedDAAQs.length < 1}
                      size="small"
                      onChange={handleAgencyChange}
                      getOptionLabel={(option) => option.label}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          className={`${props.className} ${classes.optionItem}`}
                        >
                          {option.label}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                            placeholder:
                              selectedAgencies.length < 1
                                ? "Agence de sinistre"
                                : "",
                            endAdornment: null,
                            classes: {
                              root: classes.selectInputDialog,
                            },
                          }}
                        />
                      )}
                      sx={{
                        fontFamily: "Poppins, sans-serif",
                        "& .MuiOutlinedInput-root": {
                          p: 1,
                          height: "fit-content",
                          width: "100%",
                          backgroundColor: "rgba(243, 246, 249, 1)",
                          fontSize: "0.75rem",
                          display: "flex",
                          justifyContent:"space-between",
                          fontFamily: "Poppins",
                          border: "none",
                            "& fieldset": {
                            border: "none",
                          },
                        },
                        "& .MuiAutocomplete-popupIndicator": {
                          display: "none",
                        },
                        "& .MuiAutocomplete-tag": {
                          bgcolor: "rgba(240, 243, 199, 1)",
                          color: "rgba(187, 200, 8, 1)",
                          border: "none",
                          borderColor: "primary.light",
                          fontSize: "0.75rem",
                          padding: "2px 6px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "4px 6px", 
                        },
                        "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                          color: "rgba(187, 200, 8, 1)",
                          "&:hover": {
                            color: "rgba(187, 200, 8, 1)",
                          },
                        },
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.label === value.label
                      }
                    />
                  </div>
                </div>
              </AccordionPanel>
            </AccordionItem>
            <AccordionItem>
              <AccordionButton
                style={{
                  height: "47px",
                  border: "none",
                  background: "rgba(255, 255, 255, 1)",
                  borderBottom: "none",
                }}
              >
                <AccordionIcon
                  size="30px"
                  style={{
                    backgroundColor: "rgba(240, 243, 199, 1)",
                    width: "25px",
                    height: "25px",
                    borderRadius: "5px",
                    color: "rgba(187, 200, 8, 1)",
                  }}
                />
                <Box
                  as="div"
                  textAlign="left"
                  marginLeft="20px"
                  style={{
                    color: "rgba(0, 34, 38, 1)",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "21px",
                    fontFamily: "Poppins",
                  }}
                >
                  Habilitation Groupe
                </Box>
              </AccordionButton>
              <AccordionPanel>
                <div style={{ marginLeft: "1rem" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "1rem",
                    }}
                  >
                    <label
                      className={classes.cardText}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      Autorités du groupe
                    </label>
                    <Autocomplete
                      multiple
                      id="Authorities"
                      options={authorities}
                      value={selectedAuthorities}
                      size="small"
                      onChange={handleAuthorityChange}
                      getOptionLabel={(option) =>
                        translateAuthorities(option.label)
                      }
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          className={`${props.className} ${classes.optionItem}`}
                        >
                          {translateAuthorities(option.label)}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                            placeholder:
                              selectedAuthorities.length < 1
                                ? "Autorités du groupe"
                                : "",
                            endAdornment: null,
                            classes: {
                              root: classes.selectInputDialog,
                            },
                          }}
                        />
                      )}
                      sx={{
                        fontFamily: "Poppins, sans-serif",
                        "& .MuiOutlinedInput-root": {
                          p: 1,
                          height: "fit-content",
                          width: "100%",
                          backgroundColor: "rgba(243, 246, 249, 1)",
                          fontSize: "0.75rem",
                          display: "flex",
                          justifyContent:"space-between",
                          fontFamily: "Poppins",
                          border: "none",
                            "& fieldset": {
                            border: "none",
                          },
                        },
                        "& .MuiAutocomplete-popupIndicator": {
                          display: "none",
                        },
                        "& .MuiAutocomplete-tag": {
                          bgcolor: "rgba(240, 243, 199, 1)",
                          color: "rgba(187, 200, 8, 1)",
                          border: "none",
                          borderColor: "primary.light",
                          fontSize: "0.75rem",
                          padding: "2px 6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "2px",
                        },
                        "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                          color: "rgba(187, 200, 8, 1)",
                          "&:hover": {
                            color: "rgba(187, 200, 8, 1)",
                          },
                        },
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.label === value.label
                      }
                    />
                  </div>
                </div>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </DialogContent>
        <DialogActions style={{backgroundColor: "rgba(244, 244, 244, 1)"}}>
        <Button
            style={{
              fontFamily: "Poppins",
              fontSize: "10.76px",
              fontWeight: 600,
              lineHeight: "16.14px",
              textAlign: "left",
              color: "rgba(255, 54, 54, 1)",
              background: "rgba(255, 229, 229, 1)",
              width: "62px",
              height: "26px",
              borderRadius: "5.38px",
              marginRight: "10px",
              "&:hover": {
                background: "rgba(255, 229, 229, 1)",
              },
            }}
            onClick={handleCloseDialog}
            color="secondary"
          >
            Annuler
          </Button>
          <Button
            style={{
              fontFamily: "Poppins",
              fontSize: "10.76px",
              fontWeight: 600,
              lineHeight: "16.14px",
              textAlign: "left",
              color: "rgba(255, 255, 255, 1)",
              background: "rgba(60, 101, 86, 1)",
              width: "61.08px",
              height: "26.71px",
              borderRadius: "5.38px",
              marginRight: "10px",
              "&:hover": {
                background: "rgba(187, 200, 8, 1)",
              },
            }}
            onClick={handleSubmit}
            color="primary"
          >
            {isEditing ? "Modifier" : "Valider"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openConfirm}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseConfirm}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle
          className={classes.dialogTitle}
          style={{ backgroundColor: "rgba(243, 246, 249, 1)" }}
        >
          {"Confirmation de suppression"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            style={{
              fontFamily: "Poppins",
              fontSize: "16px",
            }}
          >
            Êtes-vous sûr de supprimer le groupe d'utilisateurs <br />«{" "}
            {groupToDelete?.label} »
            <br />
            Les utilisateurs rattachés perdront ce groupe ; les visibilités partagées avec d'autres groupes ou utilisateurs sont conservées.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseConfirm}
            style={{
              fontFamily: "Poppins",
              fontSize: "10.76px",
              fontWeight: 600,
              lineHeight: "16.14px",
              textAlign: "left",
              color: "rgba(255, 255, 255, 1)",
              background: "rgba(60, 101, 86, 1)",
              width: "fit-content",
              height: "26px",
              borderRadius: "5.38px",
              marginRight: "10px",
              cursor: "pointer",
            }}
          >
            Annuler
          </Button>
          <Button
            onClick={handleConfirmDelete}
            style={{
              fontFamily: "Poppins",
              fontSize: "10.76px",
              fontWeight: 600,
              lineHeight: "16.14px",
              textAlign: "left",
              color: "rgba(255, 54, 54, 1)",
              background: "rgba(255, 229, 229, 1)",
              width: "fit-content",
              height: "26.71px",
              borderRadius: "5.38px",
              marginRight: "10px",
            }}
          >
            Supprimer
          </Button>
        </DialogActions>
      </Dialog>
      {isRequestInProgress && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "8px",
              textAlign: "center",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="spinner" style={{ marginBottom: "10px" }}></div>{" "}
            <p style={{ fontFamily: "Poppins", fontSize: "16px", margin: 0 }}>
              Veuillez patienter...
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
